//#region src/lib/translatable.ts
function translatable(key, _defaultValue) {
	return key;
}

//#endregion
export { translatable };
//# sourceMappingURL=index.js.map